// extracted by mini-css-extract-plugin
module.exports = {"icon":"CheckMark_icon__1Hzkj","containerCheckmark":"CheckMark_containerCheckmark__14O2T","check":"CheckMark_check__2F_CD"};